export default {
  "content": "<path d=\"M14.253.833a.533.533 0 00-.746-.02l-6.7 6.24c-.3.28-.467.674-.467 1.08.007.407.18.8.487 1.074l6.653 5.966c.213.194.547.18.747-.033l.593-.64c.2-.22.187-.56-.033-.76L8.5 8.113l6.333-5.893c.22-.2.227-.547.02-.76l-.6-.627zM1 1a.5.5 0 01.5-.5h.75a.5.5 0 01.5.5v14a.5.5 0 01-.5.5H1.5A.5.5 0 011 15V1z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};